import { apiGet, apiPost } from './client'

/**
 * Comenzile in zbor - `sidebar/remote_control/inflight*` din portal
 * (`InflightController`, peste `Services\Work\Inflight`).
 */
export const INFLIGHT_STATES = ['running', 'waiting', 'failed', 'succeeded', 'changes', 'tickets'] as const
export type InflightState = (typeof INFLIGHT_STATES)[number]
export type InflightScope = 'mine' | 'company'

export type InflightCounts = Record<InflightState, number>

export interface InflightBadges extends InflightCounts {
  scope: InflightScope
  can_clear_any: boolean
}

export interface InflightRow {
  id: number
  origin: string
  state: string
  device_id: number
  device_name: string
  user_id: number
  user_name: string
  type: string
  command: string
  channel?: string
  message: string
  at: string
}

export interface InflightRows {
  rows: InflightRow[]
  scope: InflightScope
  may_company: boolean
  refused: boolean
  state: string | null
  counts: { mine: InflightCounts; company?: InflightCounts }
}

export function inflightBadges(scope: InflightScope = 'mine'): Promise<InflightBadges> {
  return apiGet(`/sidebar/inflight?scope=${scope}`)
}

export function inflightRows(scope: InflightScope, state: InflightState | ''): Promise<InflightRows> {
  return apiGet(`/sidebar/inflight/rows?scope=${scope}&state=${state}`)
}

export function inflightClear(origin: string, id: number): Promise<{ ok?: boolean; status?: string; message?: string }> {
  return apiPost('/sidebar/inflight/clear', { origin, id })
}

export function inflightResend(origin: string, id: number): Promise<{ ok?: boolean; status?: string; message?: string }> {
  return apiPost('/sidebar/inflight/resend', { origin, id })
}
